var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Tooltip',{attrs:{"content":_vm.statusClass.tooltip,"placement":"top","transfer":""}},[_c('i',{staticClass:"iconfont status",class:_vm.statusClass.name})])
}
var staticRenderFns = []

export { render, staticRenderFns }